import {Component, OnInit, Input, Output, EventEmitter, ViewChild} from '@angular/core';
import {BsModalService, BsModalRef} from 'ngx-bootstrap/modal';
import {CommonService} from '../../services/common.service';
import * as moment from 'moment';

@Component({
  selector: 'app-solde',
  templateUrl: './solde.component.html',
  styleUrls: ['./solde.component.css']
})
export class SoldeComponent implements OnInit {
  @Input() detail;
  @Input() edit: Boolean;
  @Input() add: Boolean;
  @Input() hidetitle: Boolean;

  @Output() prixNegocier = new EventEmitter<any>();

  default = 0;
  nbdigit;
  result: any[] = [];
  modepaie;
  modefacturejrxml;
  jours: any[] = [];
  typemodepaie;
  comm1;
  comm2;
  formspec;
  typeQteDASRI;
  site;
  siteCA;
  groupimp;
  typeflux;
  listCom = [];
  listMode = [];
  listFormspe = [];
  listQtedasri = [];
  listSite = [];
  listGrpimp = [];
  listTypeflux = [];
  listComptes = [];
  listCompte = [];
  listPrestation = [
    {id: 0, libelle: 'Depot'},
    {id: 1, libelle: 'Rotation'},
    {id: 2, libelle: 'Retrait'},
    {id: 3, libelle: 'Autre'},
    {id: 4, libelle: 'Location'},
    {id: 5, libelle: 'Forfait'},
  ];
  devise = '';

  reglement: any = {};
  @ViewChild('prixPrestation') prixPrestation;
  @ViewChild('confirmationChorus') confirmationChorus;
  @ViewChild('msg') msg;
  error = '';
  cpatchaTextBox = '';
  code = '';
  isSoldeParChantier:boolean = false;
  compteRegie :any = {};
  siteUser :any = {};

  constructor(public common: CommonService, private modalService: BsModalService) {
  }

  ngOnInit() {
    this.nbdigit = this.common.local.getObject('paramSociete').nbDigitDevise;
    this.devise = this.common.local.getObject('paramSociete').devise || '€';
    this.isSoldeParChantier = this.common.local.getObject('paramSociete').soldeParChantier ? true :  false;
    this.siteUser = this.common.local.getObject('siteUser') || {};
    if(!this.isSoldeParChantier){
      this.detail['isCompte'] = this.detail['isCompte'] || false;
      this.detail['infoChanterSynthetique'] = this.detail['infoChanterSynthetique'] || false;
      this.detail['factBonImmediat'] = this.detail['factBonImmediat'] || false;
      this.detail['fraisFacturation'] = this.detail['fraisFacturation'] || false;
      this.detail['numBonManuelObligatoire'] = this.detail['numBonManuelObligatoire'] || false;
    }
    this.listChamp();

  }

  listChamp() {
    this.typemodepaie = this.common.getItem(this.common.getType('typeModepaie'), (this.detail.modePaie || 0));
    this.listComptes = this.common.local.getObject('paramSociete').listCompte || [];

    this.searchModepaie();
    this.searchCompte();
    return true;
  }


  searchModepaie(event?) {
    // this.listMode = [];
    // this.common.getType('typeModepaie').forEach(elt => {
    //   // if (elt.libelle.startsWith(event) || elt.libelle.toLowerCase().startsWith(event)) {
    //   elt.libelleObjetEntite = elt.libelle;
    //   this.listMode.push(elt);
    //   // }
    // });
    this.listMode = [];
    const param = {
      'servlet': 'DBGestionTypePaiement',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 2
        },
      }
    };

    this.common.post('', {param: param}).then(datas => {
      if (this.common.verifySession(datas)) {
        if (datas.data) {
          const liste = (datas.data || []).filter(elt => !elt.masque);
          if (liste.length) {
            liste.forEach(elt => {
              elt.libelleObjetEntite = elt.libelleObjetEntite || elt.libelle;
              if (elt.id === parseInt((this.detail.modePaie || 0), 10)) {
                this.modepaie = elt;
              }
              this.listMode.push(elt);
            });
            // this.common.sortByID(this.listMode);
            this.initReglement()
          }
        }
      }
    });
  }


  showPrixNego() {
    this.prixNegocier.emit();
  }

  getCompte(id) {
    const elem = this.listComptes.filter(elt => elt.id === id);
    return elem ? elem[0] : '';
  }

  Tofixed(value) {
    return parseFloat(value).toFixed(this.nbdigit);
  }

  searchCompte(event?) {
    this.listCompte = [];
    this.listComptes.forEach(elt => {
      // if (elt.numCompte.startsWith(event) || elt.numCompte.toLowerCase().startsWith(event)) {
      elt.libelleObjetEntite = (elt.nomBanque ? elt.nomBanque + '/' : '') + elt.numCompte;
      this.listCompte.push(elt);
      // }
    });
  }

  initReglement() {
    this.reglement['montant'] = 0;
    this.listCompte = this.listCompte || []
    this.reglement['compte'] = this.listCompte && this.listCompte.length > 0 ? this.listCompte[0] : {id: 0};
    this.listCompte.forEach(elt => {
      if(this.siteUser && this.siteUser.compteRegie && this.siteUser.compteRegie.id && elt.id === this.siteUser.compteRegie.id  ) {
        this.compteRegie = elt || {};
        this.reglement['compte'] = this.compteRegie
      }
    });

    this.reglement['modepaie'] = this.listMode && this.listMode.length > 0 ? this.listMode[0] : {id: 0};
  }

  valideRegelement() {
    this.detail['nomclass'] = 'Client';
    if(this.isSoldeParChantier)
      this.detail['nomclass'] = 'Chantier';
    this.detail['solde'] = (parseFloat(this.detail['solde'] || 0) + this.reglement['montant']);
    const regelement = {
      nomclass: 'Reglement',
      date: moment().format('DD/MM/YYYY'),
      montant: this.reglement['montant'],
      compte: this.reglement['compte'],
      type: this.reglement['modepaie'],
      client: !this.isSoldeParChantier ?this.detail : {},
      chantier: this.isSoldeParChantier ?this.detail : {}
    }
    const param = {
      'servlet': 'DBReglement',
      'module': 'Ecodechet',
      'type': 'liste',
      'compression': 'false',
      'data': [['DBReglement'], regelement,  {
        'typeParam': 'boolean',
        'valeur': true
      }, {
        'typeParam': 'int',
        'valeur': this.common.user[0]
      }]
    };
    const montant = this.reglement['montant'];

    return this.common.post('', {param: param}).then(datas => {
      if (!datas.message) {
        // this.detail['solde'] = (parseFloat(this.detail['solde']) + montant);
        this.initReglement()
      } else {
        this.error = datas.message;
        this.common.openModal(this.modalService, this.msg);
      }
    });
  }


}

